import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { loadItem, saveItem, storageKeys } from "../storage/index";
import {
  DEFAULT_LANGUAGE,
  normalizeLanguageCode,
  translate,
} from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(
    () => normalizeLanguageCode(loadItem(storageKeys.appLanguage, DEFAULT_LANGUAGE)),
  );

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = useCallback((nextLanguage) => {
    const normalized = normalizeLanguageCode(nextLanguage);
    setLanguageState(normalized);
    saveItem(storageKeys.appLanguage, normalized);
  }, []);

  const t = useCallback(
    (key, vars) => translate(language, key, vars),
    [language],
  );

  const value = useMemo(
    () => ({ language, setLanguage, t }),
    [language, setLanguage, t],
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
}
